import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use localStorage explicitly for Cloudflare Pages compatibility
    storage: window.localStorage,
    storageKey: 'undagi-auth-token',
    // Don't sign out on tab visibility change
    flowType: 'pkce',
  },
  global: {
    headers: {
      'x-app-name': 'undagi-v4',
    },
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})

export const storageBuckets = {
  photos: 'report-photos',
  documents: 'project-documents',
}

export const uploadFile = async (bucket, file, path) => {
  const { data, error } = await supabase.storage
    .from(bucket)
    .upload(path, file, { cacheControl: '3600', upsert: false })

  if (error) throw error

  const { data: { publicUrl } } = supabase.storage
    .from(bucket)
    .getPublicUrl(data.path)

  return { path: data.path, url: publicUrl }
}

export const deleteFile = async (bucket, path) => {
  const { error } = await supabase.storage.from(bucket).remove([path])
  if (error) throw error
}